import { EntityType } from '@frontend/common';
import { EquipmentExtended } from '@frontend/equipment/types';

export interface LendingEquipmentUsageDisplay {
    productName: string | null;
    productEntityId: string | null;
    productEntityType: string | null;
    serialNumber: string | null;
    /** Tag only when present and different from the serial. */
    tagName: string | null;
    /** True when product is missing — UI should render an equipment ObjectBadge for the id. */
    showEquipmentBadge: boolean;
    equipmentId: string;
}

const distinctTagName = (serialNumber: string | null | undefined, tagName: string | null | undefined): string | null => {
    const tag = tagName?.trim() || null;
    if (!tag) {
        return null;
    }

    const serial = serialNumber?.trim() || null;
    if (serial && tag.toLowerCase() === serial.toLowerCase()) {
        return null;
    }

    return tag;
};

export const toLendingEquipmentUsageDisplay = (equipment: EquipmentExtended | null | undefined, rawSeriesKey: string): LendingEquipmentUsageDisplay => {
    const equipmentId = equipment?.id?.trim() || rawSeriesKey.trim();
    const productName = equipment?.product?.name?.trim() || null;
    const serialNumber = equipment?.serial_number?.trim() || null;
    const tagName = distinctTagName(serialNumber, equipment?.tag?.name);

    if (productName) {
        return {
            productName,
            productEntityId: equipment?.product?.entity_id ?? equipment?.product_id ?? null,
            productEntityType: equipment?.product?.entity_type ?? EntityType.PRODUCT,
            serialNumber,
            tagName,
            showEquipmentBadge: false,
            equipmentId
        };
    }

    return {
        productName: null,
        productEntityId: null,
        productEntityType: null,
        serialNumber,
        tagName,
        showEquipmentBadge: true,
        equipmentId
    };
};
